import * as _ from 'lodash';
const COLOR_CODES_WITH_STATUS = {
  'MCOFF' : {
    'StatusCode' : 200,
    'ColorCode' : '#3F3F3F'
  },
  'CONNECTOFF' : {
    'StatusCode' : 201,
    'ColorCode' : '#777777'
  },
  'IDLE' : {
    'StatusCode' : 0,
    'ColorCode' : '#CFCFCF'
  },
  'Wait Switch' : {
    'StatusCode' : 1,
    'ColorCode' : '#BBE3E3'
  },
  'Run' : {
    'StatusCode' : 3,
    'ColorCode' : '#00E396'
  },
  'Error Stop' : {
    'StatusCode' : 5,
    'ColorCode' : '#FF5543'
  },
  'Wait Previous' : {
    'StatusCode' : 11,
    'ColorCode' : '#FEA860'
  },
  'Wait Next' : {
    'StatusCode' : 12,
    'ColorCode' : '#FFD447'
  },
  'Loading' : {
    'StatusCode' : 13,
    'ColorCode' : '#AEDC8A'
  },
  'Maintenance' : {
    'StatusCode' : 14,
    'ColorCode' : '#8568AC'
  },
  'Wait Setup' : {
    'StatusCode' : 15,
    'ColorCode' : '#5f34f5'
  },
  'Change Over' : {
    'StatusCode' : 101,
    'ColorCode' : '#DAB4CF'
  }
};
const COLOR_CODES = {};
const PnPUtilService = {
  PNP_MACHINE_STATUS_REFRESH : 180000,
  getColorCodes : ()=>{
    if(_.isEmpty(COLOR_CODES)){
      let listOfStatus = _.keys(COLOR_CODES_WITH_STATUS);
      listOfStatus.forEach((status)=>{
        COLOR_CODES[status.toUpperCase()] = COLOR_CODES_WITH_STATUS[status].ColorCode
      });
    }
    return COLOR_CODES;
  }
};
export default PnPUtilService;